import { useState, useEffect } from 'react'
import Weatherpanel from "./weatherpanel.js"
import styles from './css/dashboard.module.css'

export default function Dashboard(props) {

    const [points, setpoints] = useState([]);

    useEffect(() => {
        if (props.points.length > 0) {
            setpoints(props.points);
        }
    }, [props.points]);

    useEffect(() => {
        sortPoints();
    }, [points]);

    function openSite(name) {
        if (props.setsite) props.setsite({ menu: "site", site: name });
    }

    function sortPoints() {
        function diff(a, b) {
            if (a === b) return 0
            else if (a == null) return 1
            else if (b == null) return -1
            else return a < b ? 1 : -1;
        }
        points.sort((a, b) => diff(a.latitude, b.latitude));
    }

    sortPoints()

    return (
        <div className={styles.body}>
            <div className={styles.header}>
                <div className={styles.title}>ダッシュボード</div>
                <div className={styles.discription}>風速:過去1分間の平均・雨量:過去1時間の合計・震度:過去24時間の最大の震度</div>
            </div>
            <div className={styles.container} id="dashboard_content">
                {
                    points.map((point, idx) => (
                        <div className={styles.point} onClick={() => { openSite(point.name) }}>
                            <div className={styles.name}>{point.name}</div>
                            <div className={styles.weatherpanel}><Weatherpanel point={point} small/></div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}